import { ASSESSMENTS, CONFIGURATION, TIMING, TPRM } from 'Config/Paths';
import { CreateDueDiligenceAssessmentConfigurationRequest, DueDiligenceAssessmentConfiguration, UpdateDueDiligenceAssessmentConfigurationRequest } from 'Models/DueDiligence';
import { DueDiligenceTimeframes, UpdateDueDiligenceTimeframesRequest } from 'Models/DueDiligenceWorkflow';
import { ResponseModel } from 'Models/ResponseModel';
import { restApiDelete, restApiGet, restApiPost } from 'RestApiConnector';

import { DueDiligenceAssessmentConfigurationApi } from './DueDiligenceAssessmentConfigurationApi';

export class AWSDueDiligenceAssessmentConfigurationApi implements DueDiligenceAssessmentConfigurationApi {
    getTimeframes = (): Promise<ResponseModel<DueDiligenceTimeframes>> => {
        return restApiGet(`/${TPRM}/${CONFIGURATION}/${TIMING}`, {});
    };
    updateTimeframes = (request: UpdateDueDiligenceTimeframesRequest): Promise<ResponseModel<void>> => {
        return restApiPost(`/${TPRM}/${CONFIGURATION}/${TIMING}`, request);
    };

    getAssessmentConfiguration = (assessmentId: string): Promise<ResponseModel<DueDiligenceAssessmentConfiguration>> => {
        return restApiGet(`/${TPRM}/${CONFIGURATION}/${ASSESSMENTS}/${assessmentId}`, {});
    };
    getAllAssessmentConfigurations = (): Promise<ResponseModel<DueDiligenceAssessmentConfiguration[]>> => {
        return restApiGet(`/${TPRM}/${CONFIGURATION}/${ASSESSMENTS}`, {});
    };
    createAssessmentConfiguration = (request: CreateDueDiligenceAssessmentConfigurationRequest): Promise<ResponseModel<DueDiligenceAssessmentConfiguration>> => {
        return restApiPost(`/${TPRM}/${CONFIGURATION}/${ASSESSMENTS}`, request);
    };
    updateAssessmentConfiguration = (assessmentId: string, request: UpdateDueDiligenceAssessmentConfigurationRequest): Promise<ResponseModel<void>> => {
        return restApiPost(`/${TPRM}/${CONFIGURATION}/${ASSESSMENTS}/${assessmentId}`, request);
    };
    deleteAssessmentConfiguration = (assessmentId: string): Promise<ResponseModel<void>> => {
        return restApiDelete(`/${TPRM}/${CONFIGURATION}/${ASSESSMENTS}/${assessmentId}`);
    };
}
